import useOptimizelyScrollDepth from '#hooks/useOptimizelyScrollDepth';

const ScrollDepthTracking = () => {
  useOptimizelyScrollDepth();
  return null;
};

export default ScrollDepthTracking;
